import {Injectable} from '@angular/core';
import {HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ServicesService} from '../lib/rest-service/services.service';
import {Page} from '../lib/core/common/dto/Page';
import {TikTokPostChartDTO} from '../dto/chart/TikTokPostChartDTO';
import {InstagramPostChartDTO} from '../dto/chart/InstagramPostChartDTO';
import {HomeInfoDTO} from '../dto/HomeInfoDTO';
import {AllAvailableChartDTO} from "../dto/AllAvailableChartDTO";

@Injectable()
export class ChartsService {

  public readonly BASE_URL: string = 'charts';

  constructor(private services: ServicesService) {
  }

  getHomeInfo(): Observable<HttpResponse<HomeInfoDTO>> {
    return this.services.get<HomeInfoDTO>(
      this.BASE_URL + '/home/info',
      {},
      null);
  }

  getAvailableCharts(): Observable<HttpResponse<AllAvailableChartDTO>> {
    return this.services.get<AllAvailableChartDTO>(
      this.BASE_URL + '/available/chart',
      {},
      'Impossibile recuperare le informazioni');
  }

  getInstagramChart(chartId): Observable<HttpResponse<Page<InstagramPostChartDTO>>> {
    return this.services.get<Page<InstagramPostChartDTO>>(
      this.BASE_URL + '/post/instagram/' + chartId,
      {},
      'Impossibile recuperare la classifica');
  }

  getTikTokChart(chartId): Observable<HttpResponse<Page<TikTokPostChartDTO>>> {
    return this.services.get<Page<TikTokPostChartDTO>>(
      this.BASE_URL + '/post/tiktok/' + chartId,
      {},
      'Impossibile recuperare la classifica');
  }

}
